/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { ControlState } from "../models/flexible/control-state";
import { combinePaths } from "../models/flexible/utils";
import { CoverageRequestTherapyDecision, Maybe } from "../models/generated/graphql";
import { getPathPrefix } from "../utils/get-path-prefix";
import { GeneralFieldController } from "./general-field-controller";
import { useTranslation } from "react-i18next";
import { FlexControlProps } from "../models/flexible/flex-field-controller";

export class CoverageEndDateFieldController extends GeneralFieldController {
	override useControlState(path: string): ControlState {
		const [decisionTherapy] = useFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.DecisionTherapy));
		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) return "disabled";

		return decisionTherapy === CoverageRequestTherapyDecision.Approved ? "enabled" : "hidden";
	}

	override useControlProps(path: string): Maybe<FlexControlProps> | undefined {
		const { t } = useTranslation();

		if (this.parent.context.noPatients && this.parent.context.noPatients > 0) {
			return {
				isTranslated: true,
				emptyValuePlaceholder: t("bulk-coverage-coverage-end-placeholder"),
			};
		}

		return null;
	}

	override createValidationRule(initialValues: unknown, translate: (key: string) => string): Yup.AnySchema {
		return super
			.createFieldValidationRuleByDataType(translate)
			.when([AttributeIdentifiers.DecisionTherapy, AttributeIdentifiers.CoverageStartDate], ((
				therapyDecision: CoverageRequestTherapyDecision,
				coverageStartDate: Date,
				schema: Yup.DateSchema<any>
			) =>
				therapyDecision === CoverageRequestTherapyDecision.Approved && !!coverageStartDate
					? schema.min(coverageStartDate, `${translate("cannot-be-less-than")} ${translate("coverageStartDate")}`)
					: schema) as any).nullable();
	}
}
